import React from "react";

import "./close-icon.m.css";

const CloseIcon = () => {
  return (
    <svg id="highlight_off-24px" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" styleName="wrapper">
      <path id="Path_132924" data-name="Path 132924" d="M0,0H22V22H0Z" fill="none"/>
      <path id="Path_132925" data-name="Path 132925" d="M12.7,8.03,11,9.731,9.3,8.03A.9.9,0,0,0,8.03,9.3l1.7,1.7-1.7,1.7A.9.9,0,0,0,9.3,13.97l1.7-1.7,1.7,1.7A.9.9,0,0,0,13.97,12.7l-1.7-1.7,1.7-1.7a.9.9,0,0,0,0-1.269A.913.913,0,0,0,12.7,8.03ZM11,2a9,9,0,1,0,9,9A8.992,8.992,0,0,0,11,2Zm0,16.2A7.2,7.2,0,1,1,18.2,11,7.21,7.21,0,0,1,11,18.2Z" />
    </svg>
  )
}

export default CloseIcon;
